<template>
  <div>
    <el-container>
      <el-main>
        <el-row>
          <el-col :span="24">
            <ReportByProductByMonthFilters
              @onYearSelected="OnYearSelected"
              @thecnicianChaged="OnThecnicianChaged"
              @customerServiceChanged="OnCustomerServiceChanged"
              @resquestTypeChanged="OnRequestTypeChanged"
            />
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <ReportByModuleByMonthTable
              :yearSelected="yearSelected"
              :thecnicianSelected="thecnicianSelected"
              :customerServiceCode="customerServiceCode"
              :requestTypeSelected="requestTypeSelected"
              @OpeningDetailDialosg="OnDetailDialogOpen"
            />
          </el-col>
        </el-row>
        <MonthlyRequstsByModulesReportDetail
          :DialoVisible="detailDialogVisible"
          :YearSelected="yearSelected"
          :ThecnicianSelected="thecnicianSelected"
          :CustomerServiceCode="customerServiceCode"
          :Month="monthSelected"
          :ModuleId="moduleId"
          :ModuleName="moduleName"
          :RequestTypeSelected="requestTypeSelected"
          @ClosingDialog="OnDetailDialogClose"
        />
      </el-main>
    </el-container>
  </div>
</template>

<script>
import ReportByProductByMonthFilters from "@/components/requests/reports/reportByproductByMonth/ReportByProductByMonthFilters";
import ReportByModuleByMonthTable from "@/components/requests/reports/ReportByModuleByMonth/ReportByModuleByMonthTable";
import MonthlyRequstsByModulesReportDetail from "@/components/requests/reports/ReportByModuleByMonth/detaill/MonthlyRequstsByModulesReportDetail";

const actualYear = new Date().getFullYear();

export default {
  name: "ClientRabbeyRequestByModule",
  components: {
    ReportByProductByMonthFilters,
    ReportByModuleByMonthTable,
    MonthlyRequstsByModulesReportDetail
  },
  data() {
    return {
      yearSelected: actualYear,
      monthSelected: null,
      thecnicianSelected: 0,
      customerServiceCode: 0,
      requestTypeSelected: 0,
      moduleId: null,
      moduleName: "",
      detailDialogVisible: false
    };
  },

  mounted() {},

  methods: {
    OnYearSelected(year) {
      this.yearSelected = year;
    },
    OnThecnicianChaged(thecnicianId) {
      this.thecnicianSelected = thecnicianId;
    },
    OnCustomerServiceChanged(customerServiceCode) {
      this.customerServiceCode = customerServiceCode;
    },
    OnRequestTypeChanged(requestType) {
      this.requestTypeSelected = requestType;
    },
    OnDetailDialogOpen(val, month, moduleId, moduleName) {
      this.monthSelected = month;
      this.moduleId = moduleId;
      this.moduleName = moduleName;
      this.detailDialogVisible = val;
    },
    OnDetailDialogClose(val) {
      this.detailDialogVisible = val;
    }
  }
};
</script>
